import { SearchSelect } from "@/components/shared/SearchSelect";

const CODES = [
  ["+65", "Singapore"], ["+60", "Malaysia"], ["+62", "Indonesia"], ["+63", "Philippines"], ["+66", "Thailand"],
  ["+84", "Vietnam"], ["+95", "Myanmar"], ["+855", "Cambodia"], ["+856", "Laos"], ["+673", "Brunei"],
  ["+91", "India"], ["+977", "Nepal"], ["+880", "Bangladesh"], ["+94", "Sri Lanka"], ["+92", "Pakistan"],
  ["+86", "China"], ["+852", "Hong Kong"], ["+886", "Taiwan"], ["+81", "Japan"], ["+82", "South Korea"],
  ["+61", "Australia"], ["+64", "New Zealand"], ["+971", "UAE"], ["+966", "Saudi Arabia"], ["+974", "Qatar"],
  ["+44", "United Kingdom"], ["+1", "USA / Canada"], ["+33", "France"], ["+49", "Germany"], ["+39", "Italy"],
  ["+34", "Spain"], ["+41", "Switzerland"], ["+31", "Netherlands"], ["+7", "Russia"], ["+27", "South Africa"],
  ["+234", "Nigeria"], ["+254", "Kenya"], ["+20", "Egypt"], ["+55", "Brazil"], ["+52", "Mexico"],
];

export const splitPhone = (value = "") => {
  const m = String(value).trim().match(/^(\+\d{1,4})\s*(.*)$/);
  return m ? [m[1], m[2]] : ["+65", String(value || "")];
};

export const isValidPhone = (value = "") => /^\+\d{1,4} \d{6,14}$/.test(String(value).trim());

export const PhoneInput = ({ value, onChange, className = "", testid = "phone", required = false }) => {
  const [code, number] = splitPhone(value);
  className = className.replace(/\bw-full\b/g, "");
  const emit = (c, n) => onChange(`${c} ${n.replace(/[^\d]/g, "")}`.trim());
  return (
    <div className="flex gap-2">
      <SearchSelect value={code} onChange={(e) => emit(e.target.value, number)} data-testid={`${testid}-code`}
        className={`${className} w-[8.5rem] shrink-0`} aria-label="Country code">
        {CODES.map(([c, n]) => <option key={`${c}-${n}`} value={c}>{c} {n}</option>)}
      </SearchSelect>
      <input type="tel" inputMode="numeric" required={required} value={number} placeholder="Phone number"
        onChange={(e) => emit(code, e.target.value)} data-testid={`${testid}-number`} className={`${className} min-w-0 flex-1`} />
    </div>
  );
};
